<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import type {
  ISatMenuSelectorProps,
  ISatMenuSelectorEmits,
} from "@chatfood/design-system";
import { AtomCard, SatMenuSelector, useImage } from "@chatfood/design-system";
import { computed } from "vue";
import { useNavigation } from "~/composables/use-navigation";
import { useOutletStore } from "~/stores/outlet";
import type { IMenuSelectorProps } from "~/components/menu-selector/props";

const css = bemBuilder("menu-selector");
const props = defineProps<IMenuSelectorProps>();

const outlet = useOutletStore();

const { rawPush, resolvePath } = useNavigation();

const { optimize } = useImage();

const menus = computed<ISatMenuSelectorProps["menus"]>(() => {
  return outlet.orderingMode.menus.map((menu) => ({
    id: menu.id,
    title: menu.name,
    summary: menu.summary,
    icon: menu.icon ? optimize(menu.icon, { w: 600 }) : undefined,
    link: resolvePath("menu", {
      menuSlug: menu.slug,
      orderingMode: props.orderingMode,
      outletSlug: outlet.slug,
    }),
  }));
});

const onClick = (menu: ISatMenuSelectorEmits["select"][0]) => {
  rawPush(menu.link);
};
</script>

<template>
  <AtomCard :class="css('')">
    <SatMenuSelector :menus="menus" @select="onClick" />
  </AtomCard>
</template>
